/**
 * This mixins use to handle user refresh page while they are in create or edit page
 */
import moment from 'moment';
import User from '@/models/User';
import LearningUnit from '@/models/LearningUnit';
import Section from '@/models/Section';
import SectionRepeat from '@/models/SectionRepeat';

export const sectionMixin = {
  data() {
    return {
      sectionWhenCreateNew: null
    };
  },

  computed: {
    user() {
      return User.query().first();
    },

    userId() {
      return this.user ? this.user.id : null;
    },

    learningUnit() {
      return LearningUnit.query().with('sections').find(this.learningUnitId);
    },

    user_id() {
      return this.user ? this.user.uid : null;
    },

    learningUnitId() {
      return this.$route.params.learningUnitId;
    },

    sectionId() {
      return this.$route.params.sectionId;
    },

    $_section() {
      return this.sectionId
        ? Section.query().with('section_repeat').find(this.sectionId)
        : new Section();
    },

    sectionRepeatNotRepeat() {
      return SectionRepeat.query().where('name', 'Does not repeat').first();
    },

    sectionRepeatWeekly() {
      return SectionRepeat.query().where('name', 'Weekly').first();
    },

    sectionRepeatBiWeekly() {
      return SectionRepeat.query().where('name', 'Biweekly').first();
    },

    addedDate() {
      return (dateWithFormat, days) => moment(dateWithFormat).add(days, 'days');
    }
  },

  // watch: {
  //   learningUnitId: {
  //     immediate: true,
  //     handler(learningUnitId) {
  //       if (learningUnitId) {
  //         this.fetchLearningUnit();
  //       }
  //     },
  //   },
  // },

  async mounted() {
    // await this.fetchSectionById();
  },

  methods: {
    /**
     * Generate all online meetings from UI input data
     *
     * Pass arguments as Object with all followed keys
     * @param {String} start_at date time in UTC format (2013-02-04T10:35:24-08:00)
     * @param {String} end_at date time in UTC format (2013-02-04T10:35:24-08:00)
     * @param {Number} meeting_repeat 1 = not repeat / 2 = weekly / 3 = biweekly
     * @param {String[]} meeting_days Days of week for meeting
     * @param {String} meeting_start_time time with format HH:mm (12:00)
     * @returns {Array} date list of meetings
     */
    meetingsList({ start_at, end_at, meeting_repeat, meeting_days, meeting_start_time }) {
      /* Guard clause */
      if (!start_at || !end_at || !meeting_repeat || !meeting_days.length || !meeting_start_time)
        return [];

      const startToEndDifference = moment(end_at).diff(moment(start_at), 'days');

      /* No Repeat */
      if (meeting_repeat == this.sectionRepeatNotRepeat.id) {
        const listNoRepeat = [];
        for (let day = 0; day <= startToEndDifference; day++) {
          const date = `${this.formatedDatetime(
            this.addedDate(start_at, day),
            'YYYY-MM-DD'
          )}T${meeting_start_time}`;
          const dayOfDate = this.formatedDatetime(this.addedDate(start_at, day), 'dddd');
          /* meeting_days (days of week) is part of repeat days
                   start section date equal to meeting date & meeting time start before section time
                   end section date equal to meeting date & meeting time start after section time */
          if (
            meeting_days.includes(dayOfDate) &&
            moment(date).isSameOrAfter(start_at, 'minute') &&
            moment(end_at).diff(date, 'minutes') >= 60
          )
            listNoRepeat.push(date);
          /* break for loop when meeting lists are full */
          if (listNoRepeat.length === meeting_days.length) break;
        }
        return listNoRepeat;
      }

      /* Weekly */
      if (meeting_repeat === this.sectionRepeatWeekly.id) {
        const listWeekly = [];

        for (let day = 0; day <= startToEndDifference; day++) {
          const date = `${this.formatedDatetime(
            this.addedDate(start_at, day),
            'YYYY-MM-DD'
          )}T${meeting_start_time}`;

          const dayOfDate = this.formatedDatetime(this.addedDate(start_at, day), 'dddd');

          if (
            meeting_days.includes(dayOfDate) &&
            moment(date).isSameOrAfter(start_at, 'minute') &&
            moment(end_at).diff(date, 'minutes') >= 60
          )
            listWeekly.push(date);
        }
        return listWeekly;
      }

      /* Bi-weekly */
      if (meeting_repeat === this.sectionRepeatBiWeekly.id) {
        let listBiweekly = [];

        const sectionStartDateOfWeek = moment(new Date(start_at))
          .startOf('week')
          .format('YYYY-MM-DD');

        // console.log(sectionStartDateOfWeek, startToEndDifference);

        let biweeklyDaySteps = 14;

        for (
          let biweeklyDay = 0;
          biweeklyDay <= startToEndDifference;
          biweeklyDay += biweeklyDaySteps
        ) {
          biweeklyDaySteps = 14;

          const startDateInWeek = this.formatedDatetime(
            this.addedDate(sectionStartDateOfWeek, biweeklyDay),
            'YYYY-MM-DD'
          );

          // console.log("StartDateInWeek: ", startDateInWeek, biweeklyDaySteps, biweeklyDay);

          let currentListBiweekly = this.generateBiWeekly(
            start_at,
            end_at,
            meeting_start_time,
            meeting_days,
            startDateInWeek,
            0,
            7
          );

          // If in the first week doesn't found any matches day, move to the next week to find the first day
          if (!currentListBiweekly.length) {
            let nextWeekCurrentListBiweekly = this.generateBiWeekly(
              start_at,
              end_at,
              meeting_start_time,
              meeting_days,
              startDateInWeek,
              7,
              14
            );

            currentListBiweekly = [...currentListBiweekly, ...nextWeekCurrentListBiweekly];

            biweeklyDaySteps = 21;
          }

          // If in the first week doesn't found any matches day, move to the next week to find the first day
          // if (!listBiweekly.length) {
          //   listBiweekly = this.generateBiWeekly(
          //     listBiweekly,
          //     start_at,
          //     end_at,
          //     meeting_start_time,
          //     meeting_days,
          //     startDateInWeek,
          //     7,
          //     14
          //   );

          //   // Then change the biweeklySteps to 21 days to skip the normal biweekly week.
          //   biweeklyDaySteps = 21;
          // } else {
          //   biweeklyDaySteps = 14;
          // }

          currentListBiweekly = currentListBiweekly.splice(0, meeting_days.length);
          listBiweekly = [...listBiweekly, ...currentListBiweekly];
        }

        // console.log(listBiweekly);

        return listBiweekly;
      }
    },

    generateBiWeekly(
      start_at,
      end_at,
      meeting_start_time,
      meeting_days,
      startDateInWeek,
      startDay,
      endDay
    ) {
      let listBiweekly = [];

      for (let day = startDay; day < endDay; day++) {
        const dateInWeek = `${this.formatedDatetime(
          this.addedDate(startDateInWeek, day),
          'YYYY-MM-DD'
        )}T${meeting_start_time}`;

        const dayOfDate = this.formatedDatetime(this.addedDate(startDateInWeek, day), 'dddd');
        // console.log(day, dateInWeek);
        if (
          meeting_days.includes(dayOfDate) &&
          moment(dateInWeek).isSameOrAfter(start_at, 'minute') &&
          moment(end_at).diff(dateInWeek, 'minutes') >= 60
        ) {
          // console.log("Add!!", dateInWeek);
          listBiweekly.push(dateInWeek);
        }
      }

      return listBiweekly;
    },

    async fetchLearningUnit() {
      try {
        LearningUnit.delete(this.learningUnitId);

        await LearningUnit.api().fetchByLearningUnitId(this.learningUnitId);
      } catch (error) {
        console.log(error);
      }
    },
    async fetchSectionById() {
      try {
        if (this.sectionId) {
          Section.delete(this.sectionId);

          await Section.api().fetchById(this.sectionId);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
